export const TELEMETRY_API_BASE_ROUTE = '/api/telemetry';

export const buildTelemetryUrl = (operationId) => `${TELEMETRY_API_BASE_ROUTE}/operations/${operationId}`;
